import { getSupportedCountries } from '@/renderer/services/configService';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCurrentUser } from '../auth/authThunks';

/**
 * Thunk to fetch supported countries from backend
 */
export const fetchSupportedCountries = createAsyncThunk(
  'config/fetchSupportedCountries',
  async (_, { rejectWithValue }) => {
    try {
      const countries = await getSupportedCountries();
      return countries;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Error fetching supported countries:', error);
      return rejectWithValue(
        error instanceof Error ? error.message : 'Failed to fetch countries',
      );
    }
  },
);

/**
 * Thunk to initialize all config data on app load
 */
export const initializeConfig = createAsyncThunk(
  'config/initialize',
  async (_, { dispatch }) => {
    // Fetch supported countries
    await Promise.all([
      dispatch(fetchSupportedCountries()),
      dispatch(fetchCurrentUser()),
    ]);
    return true;
  },
);
